/**
 * Routes PWA — interface mobile standalone
 * Accessible à /pwa/*
 * Redirigé automatiquement depuis / quand l'app est en mode standalone (installée)
 *
 * Permissions :
 * - Les pompistes (is_pro_mobile) ne voient QUE l'historique des transactions.
 * - Les owners/managers/admin voient tout.
 * - Les operateurs voient les pages selon leurs privileges (show_/edit_).
 */

import multiguard from "vue-router-multiguard"
import { requireAuth, requirePwaCapability } from "@/utils/middleware"

const PwaHome      = () => import('@/views/pwa/PwaHome.vue')
const PwaHistory   = () => import('@/views/pwa/PwaHistory.vue')
const PwaProfile   = () => import('@/views/pwa/PwaProfile.vue')
const PwaVehicles  = () => import('@/views/pwa/PwaVehicles.vue')
const PwaVehicleDetail = () => import('@/views/pwa/PwaVehicleDetail.vue')
const PwaNewVehicle = () => import('@/views/pwa/PwaNewVehicle.vue')
const PwaVouchers  = () => import('@/views/pwa/PwaVouchers.vue')
const PwaNewVoucher = () => import('@/views/pwa/PwaNewVoucher.vue')

export default [
  {
    path: '/pwa',
    redirect: { name: 'PwaHome' },
  },
  {
    path: '/pwa/home',
    name: 'PwaHome',
    component: PwaHome,
    beforeEnter: multiguard([requireAuth, requirePwaCapability("canSeeHome")]),
    meta: { layout: 'pwa' },
  },
  {
    path: '/pwa/history',
    name: 'PwaHistory',
    component: PwaHistory,
    beforeEnter: multiguard([requireAuth, requirePwaCapability("canSeeTransactions")]),
    meta: { layout: 'pwa' },
  },
  {
    path: '/pwa/profile',
    name: 'PwaProfile',
    component: PwaProfile,
    beforeEnter: multiguard([requireAuth]),
    meta: { layout: 'pwa' },
  },
  {
    path: '/pwa/vehicles',
    name: 'PwaVehicles',
    component: PwaVehicles,
    beforeEnter: multiguard([requireAuth, requirePwaCapability("canSeeVehicles")]),
    meta: { layout: 'pwa' },
  },
  {
    path: '/pwa/vehicles/new',
    name: 'PwaNewVehicle',
    component: PwaNewVehicle,
    beforeEnter: multiguard([requireAuth, requirePwaCapability("canCreateVehicle")]),
    meta: { layout: 'pwa' },
  },
  {
    path: '/pwa/vehicles/:id',
    name: 'PwaVehicleDetail',
    component: PwaVehicleDetail,
    beforeEnter: multiguard([requireAuth, requirePwaCapability("canSeeVehicles")]),
    meta: { layout: 'pwa' },
  },
  {
    path: '/pwa/vouchers',
    name: 'PwaVouchers',
    component: PwaVouchers,
    beforeEnter: multiguard([requireAuth, requirePwaCapability("canSeeVouchers")]),
    meta: { layout: 'pwa' },
  },
  {
    path: '/pwa/vouchers/new',
    name: 'PwaNewVoucher',
    component: PwaNewVoucher,
    beforeEnter: multiguard([requireAuth, requirePwaCapability("canCreateVoucher")]),
    meta: { layout: 'pwa' },
  },
]
